/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useState, useContext } from 'react';
import AppContext from '../../../../Store/AppContext';
import { UltimoAtendimentoLead } from '../../../../Services/Relatorio';
import { validarPermissoesRelatorio } from '../../../../Utils/validarPermissoesPagina';
export const UltimoAtendimentoLeadContext = createContext();

const tituloTela = 'Último Atendimento Lead';

const searchData = {
	dataDe: '',
	dataAte: ''
};

function initialState() {
	return {
		searchData: searchData,
		seguradoras: [],
		usuarios: [],
		tiposContato: []
	};
}

const UltimoAtendimentoLeadProvider = ({ children }) => {
	const { showLoading, hideLoading, showMessage, setTituloTela } = useContext(AppContext);
	const [values, setValues] = useState(initialState());

	async function loadDependences() {

		const [
			validarPermissoesRelatorioAux
		] = await Promise.all([
			validarPermissoesRelatorio()
		]);

		return {
			permissoesRelatorio: validarPermissoesRelatorioAux
		};
	}

	const resetScreen = () => {
		showLoading();
		async function carregarDependencias() {
			const dependencias = await loadDependences();
			setTituloTela(tituloTela);
			setValues({
				...initialState(),
				permissoesRelatorio: await dependencias.permissoesRelatorio
			});
			hideLoading();
		}
		carregarDependencias();
	};

	const searchHandler = async () => {
		showLoading();
		const responseListarUltimoAtendimentoLead = await UltimoAtendimentoLead(values.searchData);

		if (!responseListarUltimoAtendimentoLead.success) {
			showMessage('Erro', 'Erro Inesperado durante a pesquisa.');
			hideLoading();
			return;
		}

		hideLoading();
	};

	return (
		<UltimoAtendimentoLeadContext.Provider
			value={{
				values,
				setValues,
				resetScreen,
				searchHandler
			}}
		>
			{children}
		</UltimoAtendimentoLeadContext.Provider>
	);
};

export default UltimoAtendimentoLeadProvider;
